var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._l((_vm.value),function(el){return _c('LinkDetail',_vm._b({key:el.key,attrs:{"row":_vm.row}},'LinkDetail',el,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }